import { useTranslation } from 'react-i18next'
import Loading from '@/widgets/Loading'
import AvailabilitySummary from './AvailabilitySummary'
import AvailabilityNotesCard from './AvailabilityNotesCard'
import useDyspozycjaDetails from './hooks/useDyspozycjaDetails'

function DyspozycjaDetailsPage() {
	const { t } = useTranslation()
	const {
		availability,
		deleting,
		error,
		handleBack,
		handleDelete,
		handleEdit,
		loading,
		slots,
		title,
	} = useDyspozycjaDetails()

	if (loading) {
		return <Loading />
	}

	if (!availability) {
		return (
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
				<div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
					<h1 className="text-lg font-semibold text-gray-900">{t('trainingAvailability.details.title')}</h1>
					<p className="mt-2 text-sm text-gray-700">{error || t('trainingAvailability.details.noData')}</p>
					<button
						type="button"
						onClick={handleBack}
						className="mt-4 inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
						{t('trainingAvailability.details.actions.back')}
					</button>
				</div>
			</div>
		)
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			{error && (
				<div className="rounded-md bg-yellow-50 p-4 text-sm text-yellow-800" role="alert">
					{error}
				</div>
			)}

			<header className="mb-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
				<div>
					<h1 className="text-2xl font-bold text-gray-900">{title}</h1>
					<p className="text-sm text-gray-500">
						{t('trainingAvailability.form.fields.slots')}:{' '}
						<span className="font-medium text-gray-900">{slots.join(', ') || '—'}</span>
					</p>
				</div>

				<div className="flex flex-wrap gap-2">
					<button
						type="button"
						onClick={handleEdit}
						className="rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-indigo-700">
						{t('trainingAvailability.details.actions.edit')}
					</button>
					<button
						type="button"
						onClick={handleDelete}
						disabled={deleting}
						className={`rounded-lg px-4 py-2.5 text-sm font-medium shadow-sm ${
							deleting ? 'cursor-not-allowed bg-gray-400 text-white' : 'bg-red-600 text-white hover:bg-red-700'
						}`}>
						{deleting
							? t('trainingAvailability.details.actions.deleting')
							: t('trainingAvailability.details.actions.delete')}
					</button>
				</div>
			</header>

			<div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
				<AvailabilitySummary availability={availability} />
				<AvailabilityNotesCard availability={availability} />
			</div>
		</div>
	)
}

export default DyspozycjaDetailsPage
